// import icons
import { SiExpertsexchange } from "react-icons/si";

export const Experiences = [
  {
    icon: <SiExpertsexchange className="icon" />,
    date: "October 2025 - December 2025",
    title: "Software Developer Intern - AlterSense Ltd.",
    description:
      "Worked on Django backend development, automation workflows, and legacy frontend maintenance while learning professional development practices, team collaboration, Git workflows, and Jira-based task management.",
  },
  {
    icon: <SiExpertsexchange className="icon" />,
    date: "January 2026 - Present",
    title: "AlterSense Ltd.",
    description:
      "Junior Software Developer, previously Software Developer Intern from October to December 2025. I work mainly on Django backend systems, automation workflows, and legacy frontend maintenance. I've also maintained Docker deployment pipelines for multiple client instances and worked with Git and Jira in a professional team environment.",
  },

  {
    icon: <SiExpertsexchange className="icon" />,
    date: "Project",
    title: "Altrbot",
    description:
      "Altrbot is an AlterSense RPA product built around a large SaaS Django backend. I've worked on automating document data extraction and portal submissions for client workflows, including invoices, POs, Sales Notes, Challans, EXP Services, Booking, and FCR. My work focuses on backend development, legacy frontend maintenance, and Docker deployments.",
  },

  // {
  //   icon: <SiExpertsexchange className="icon" />,
  //   date: "Project",
  //   title: "UAR Queue System",
  //   description:
  //     "UAR Queue is a client project built with React, FastAPI, and MongoDB to manage song submissions and review queues for a streamer. It replaced an inconsistent Nightbot-based workflow and taught me how to handle real-world user behavior and system exploits. The source repository is private.",
  // },

  // {
  //   icon: <SiExpertsexchange className="icon" />,
  //   date: "Project",
  //   title: "SpendWise",
  //   description:
  //     "SpendWise is a collaborative expense and income tracking web app built with React and Firebase. It was my first project developed with a team, where I gained practical experience with Git, GitHub, collaboration, and organizing a shared codebase. Visit: https://spendwise29.naimur29.site/",
  // },

  // {
  //   icon: <SiExpertsexchange className="icon" />,
  //   date: "Project",
  //   title: "Hidden Reads",
  //   description:
  //     "Hidden Reads is a web application for reading and managing light novels and web novels, built with React, TypeScript, and Firebase. Through this project, I explored CSS animations and dynamic URL systems that preserve application state. Visit: https://hiddenreads.naimur29.site/",
  // }
];
